import React from 'react';
import * as style from './faqList.module.scss';
import jump from 'jump.js';
import translations from '../../utils/translations';

const handleClick = e => {
  e.preventDefault();
  jump('#faqList');
};

const FaqSection = props => (
  <div className={`${style.faqSection} small-sections`}>
    {props.children}
    <div className="typeFonts1 typeColorDark1 text-block">
      <a href="#faqList" onClick={handleClick} className={style.faqBack}>
        {translations.t('Back to top')}
      </a>
    </div>
  </div>
);
export default FaqSection;
